import { isString } from "lodash";
import Alert from "./v2/Alert";

const Error = ({ errorMessage }) => {
  const messages = isString(errorMessage) ? errorMessage.split() : errorMessage;

  return messages.map((err, i) => (
    <Alert key={i} variant="error" containerClass="tw-mb-2" text={<div dangerouslySetInnerHTML={{ __html: err }} />} />
  ));
};

Error.defaultProps = {
  errorMessage: "",
};
export default Error;
